import React, { useMemo, type FC } from 'react'

import { useIntl } from 'react-intl'

import { Select } from 'mailup-web-components'

import { changeCriterionCallback } from 'Pages/RecipientsList/recoil/callbacks/filters'
import { criterionGroupsState } from 'Pages/RecipientsList/recoil/state/filters'
import { useRecoilCallback, useRecoilValue } from 'recoil'

interface InputGroupMatchOperatorProps {
  index: number
}

const InputGroupMatchOperator: FC<InputGroupMatchOperatorProps> = ({
  index,
}) => {
  const intl = useIntl()

  const { matchOperator } = useRecoilValue(criterionGroupsState(index))

  const changeCriterion = useRecoilCallback(changeCriterionCallback, [])

  const options = useMemo(() => {
    return [
      {
        value: 'BelongsTo',
        label: intl.formatMessage({ id: 'Load.RecipientsList.GroupBelongsTo' }),
      },
      {
        value: 'NotBelongsTo',
        label: intl.formatMessage({
          id: 'Load.RecipientsList.GroupNotBelongsTo',
        }),
      },
    ]
  }, [intl])

  const handleChange = (v: string): void => {
    void changeCriterion('matchOperator', v, index)
  }

  return (
    <Select value={matchOperator} options={options} onChange={handleChange} />
  )
}

export default InputGroupMatchOperator
